import React from 'react';

import { FallIcon } from '@vlabs/icons';
import { calculateProbabilityPercent } from '@vlabs/monokit/shared/lib/utils';
import { Tag } from '@vlabs/uikit';
import { useTranslation } from 'react-i18next';

import { BaseVideoAnalyticsDetails } from '../components/BaseVideoAnalyticsDetails';
import type { AnalyticDetailsEvent } from '../types';

type FallEvent = AnalyticDetailsEvent & {
  event: AnalyticDetailsEvent['event'] & {
    overview?: AnalyticDetailsEvent['event']['overview'] & {
      detection?: Record<string, unknown>;
    };
    fall_score?: number;
  };
};

export function FallDetails({ event }: { event: FallEvent }): React.JSX.Element {
  const { t } = useTranslation();
  const score = calculateProbabilityPercent(event.event.fall_score);
  const detection = event.event.overview?.detection;

  return (
    <BaseVideoAnalyticsDetails
      detections={detection ? [detection] : []}
      detectionType="bbox"
      event={event}
      tags={(
        <Tag
          data-testid="workspace.analyticEventDetails.extraTagType"
          icon={<FallIcon />}
          kind="neutral"
          size="large"
          value={`${t('videoAnalytics:fallAnalyticDetails.workspace.tag.label')} ${score}%`}
        />
      )}
      title={t('videoAnalytics:fallAnalyticDetails.workspace.title')}
    />
  );
}
